import * as firebase from "firebase/app";

import React, { Component } from "react";

import Footer from "../Footer";
import Meta from "../../helpers/meta";
import Nav from "../Nav";
import { Redirect } from "react-router";
import { connect } from "react-redux";
import FeatherIcon from 'feather-icons-react';
import Icon from '../../helpers/icon';
import { Link } from "react-router-dom";
// import moment from "moment";
import { Helmet } from "react-helmet";
import '../../helpers/style.css';
import BannerSlider from './BannerSlider';
import SubSlider from './SubSlider';


import TopCategories from "./TopCategories";
import ScrollItems from "./ScrollItems";
import axios from "axios";
import FloatCart from "../FloatCart";
import { addProduct, removeProduct } from "../../../services/cart/actions";


class SingleStore extends Component {
	static contextTypes = {
		router: () => null,
	};

	state = {
		store_slots: [],
		store_type: [],
		update: true,
		banners: [],
		banners_coloumn: []


	};

	forceStateUpdate = () => {
		setTimeout(() => {
			this.forceUpdate();
			if (this.state.update) {
				this.setState({ update: false });
			} else {
				this.setState({ update: true });
			}
		}, 100);
	};

	componentDidMount() {
		axios
			.post('https://pykin.in/public/api/single-store/get-slot-groups', {
				'id': this.props.match.params.type_id
			})
			.then((response) => {
				const store_type = response.data.storeType;
				const store_slots = response.data.store_slots;


				if (store_slots) {
					this.setState({
						store_slots: store_slots,
						store_type: store_type
					});
				} else {
					this.setState({
						store_slots: [],
						store_type: []
					});
				}

			});

		axios
			.post('https://pykin.in/public/api/single-store/get-store-banners', {
				'id': this.props.match.params.type_id
			})
			.then((response) => {
				const data = response.data;
				this.setState({
					banners: data,

				});

			});

		axios
			.post('https://pykin.in/public/api/single-store/get-coloumn-banners', {
				'id': this.props.match.params.type_id
			})
			.then((response) => {
				const data = response.data;
				this.setState({
					banners_coloumn: data,

				});

			});
	}


	render() {
		if (window.innerWidth > 768) {
			return <Redirect to="/" />;
		}

		if (localStorage.getItem("userSetAddress") === null) {
			// this.context.router.history.push("/search-location");
			// console.log("Redirect to search location");
			return <Redirect to="/search-location" />;
		}

		const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));
		if (Object.keys(userSetAddress).length === 0 && userSetAddress.constructor === Object) {
			return <Redirect to="/search-location" />;
		}

		localStorage.setItem("font-css", "* { font-family: 'Poppins', sans-serif; }")

		const { store_slots, store_type } = this.state;
		const { addProduct, removeProduct, cartProducts } = this.props;


		return (
			<React.Fragment>
				<Helmet>
					<style type="text/css">{localStorage.getItem("font-css")}</style>
				</Helmet>
				<Meta
					seotitle={localStorage.getItem("seoMetaTitle")}
					seodescription={localStorage.getItem("seoMetaDescription")}
					ogtype="website"
					ogtitle={localStorage.getItem("seoOgTitle")}
					ogdescription={localStorage.getItem("seoOgDescription")}
					ogurl={window.location.href}
					twittertitle={localStorage.getItem("seoTwitterTitle")}
					twitterdescription={localStorage.getItem("seoTwitterDescription")}
				/>

				<div style={{
					backgroundColor: store_type.top_bg_color ? store_type.top_bg_color : '#ffff',
					height: '11rem'
				}} className="p-4">
					<div className="d-flex " style={{ justifyContent: 'space-between', marginBottom: '4%' }}>
						<Link to={'/'}> <Icon icon="arrow-left" /> </Link>
						<div>
							<Link to={'/explore'}><Icon icon="search" style={{ height: '25px', weight: '25px', marginRight: '5px' }} /></Link>
							<Link to={'/'}><Icon icon="home" /></Link>
						</div>

					</div>

					{store_type.top_image && (<img src={`https://pykin.in${store_type.top_image}`} />)}
					<Link to={'/explore'}>
						<div className="d-flex " style={{ "justifyContent": "space-between", "border": "2px solid rgb(179 179 179 / 33%)", "padding": "10px", "borderRadius": "6px", "background": "white", "position": "relative", "top": "8%", "color": "rgb(195, 196, 194)" }}>
							<div>search items</div>
							<Icon icon="search" style={{ height: '20px', weight: '20px', color: '#c3c4c2' }} />
						</div>
					</Link>
				</div>

				<div className="p-4 mt-4 mb-100">
					<React.Fragment>
						<div style={{ "fontSize": "18px", "fontWeight": "700" }}>
							Trending Today
						</div>
						<div className="mt-3">
							<BannerSlider slides={this.state.banners} type={'0'} height={'auto'} width={'100%'} />
						</div>
					</React.Fragment>

					<React.Fragment>
						<div style={{ "fontSize": "18px", "fontWeight": "700" }} className="mt-3">
							Top Categories
						</div>
						<div className="mt-3">
							<TopCategories store_id={this.props.match.params.type_id} />
						</div>
					</React.Fragment>

					<div className="mt-3" style={{ "height": "1rem", "backgroundColor": "#c7c7c752", "width": "112%", "position": "relative", "left": "-6%" }} />

					{store_type && store_type.slot_1_name && store_slots.slot_1.items.length > 0 &&
						<React.Fragment>
							<div style={{ "fontSize": "18px", "fontWeight": "700", justifyContent: 'space-between', alignItems: 'center' }} className="mt-30 d-flex">
								<span>{store_type.slot_1_name}</span>
								<span className="view-more"><Link to={'/single-store-view-more/' + store_type.slot_1}>View More</Link> </span>

							</div>
							<div className="mt-3 mb-20">
								<ScrollItems forceStateUpdate={this.forceStateUpdate} addProduct={this.props.addProduct} removeProduct={this.props.removeProduct} cartProducts={this.props.cartProducts} items={store_slots.slot_1 ? store_slots.slot_1.items : []} />
							</div>
						</React.Fragment>
					}
					{store_type.slider_1_text &&
					<React.Fragment>
						<div style={{ "fontSize": "18px", "fontWeight": "700" }} className="mt-30">
							{store_type.slider_1_text}
						</div>
						<div className="mt-3 mb-3">
							<SubSlider slides={this.state.banners} type={'1'} height={'auto'} width={'100px'} />
						</div>
					</React.Fragment>
					}
					{store_type.slider_2_text &&
					<React.Fragment>
						<div style={{ "fontSize": "18px", "fontWeight": "700" }} className="mt-30">
							{store_type.slider_2_text}
						</div>
						<div className="mt-3 mb-4">
							<SubSlider slides={this.state.banners} type={'2'} height={'auto'} width={'300px'} />
						</div>
					</React.Fragment>
					}


					{store_type && store_type.slot_2_name && store_slots.slot_2.items.length > 0 &&
						<React.Fragment>
							<div style={{ "backgroundColor": store_type.top_bg_color, "position": "relative", "width": "100vw", "right": "1.5rem", "padding": "1.5rem" }}>

								<div style={{ "fontSize": "18px", "fontWeight": "700", justifyContent: 'space-between', alignItems: 'center' }} className="mt-3 d-flex">
									<span style={{ "fontSize": "18px", "fontWeight": "700", color: store_type.main_color }} >{store_type.slot_2_name}</span>
									<span className="view-more"><Link to={'/single-store-view-more/' + store_type.slot_2}>View More</Link> </span>
								</div>

								<div className="mt-3">
									<ScrollItems forceStateUpdate={this.forceStateUpdate} addProduct={this.props.addProduct} removeProduct={this.props.removeProduct} cartProducts={this.props.cartProducts} items={store_slots.slot_2 ? store_slots.slot_2.items : []} />
								</div>
							</div>
						</React.Fragment>}

					{store_type && store_type.slot_3_name && store_slots.slot_3.items.length > 0 &&
						<React.Fragment>
							<div style={{ "fontSize": "18px", "fontWeight": "700", justifyContent: 'space-between', alignItems: 'center' }} className="mt-30 d-flex">
								<span>{store_type.slot_3_name}</span>
								<span className="view-more"><Link to={'/single-store-view-more/' + store_type.slot_3}>View More</Link> </span>

							</div>
							<div className="mt-3 mb-20">
								<ScrollItems forceStateUpdate={this.forceStateUpdate} addProduct={this.props.addProduct} removeProduct={this.props.removeProduct} cartProducts={this.props.cartProducts} items={store_slots.slot_3 ? store_slots.slot_3.items : []} />
							</div>
						</React.Fragment>
					}

					{store_type && store_type.slot_4_name && store_slots.slot_4.items.length > 0 &&
						<React.Fragment>
							<div style={{ "backgroundColor": store_type.top_bg_color, "position": "relative", "width": "100vw", "right": "1.5rem", "padding": "1.5rem" }}>

								<div style={{ "fontSize": "18px", "fontWeight": "700", justifyContent: 'space-between', alignItems: 'center' }} className="mt-3 d-flex">
									<span style={{ "fontSize": "18px", "fontWeight": "700", color: store_type.main_color }} >{store_type.slot_4_name}</span>
									<span className="view-more"><Link to={'/single-store-view-more/' + store_type.slot_4}>View More</Link> </span>
								</div>
								<div className="mt-3">
									<ScrollItems forceStateUpdate={this.forceStateUpdate} addProduct={this.props.addProduct} removeProduct={this.props.removeProduct} cartProducts={this.props.cartProducts} items={store_slots.slot_4 ? store_slots.slot_4.items : []} />
								</div>
							</div>
						</React.Fragment>}
					{store_type.slider_3_text &&
					<React.Fragment>
						<div style={{ "fontSize": "18px", "fontWeight": "700" }} className="mt-30">
						{store_type.slider_3_text}
						</div>
						<div className="mt-3 mb-4">
							<div className="text-center scroll-x--rows-2 ">
								{this.state.banners_coloumn.length > 0 && (this.state.banners_coloumn.map((banner, index) => (
									<Link to={'/single-store-view-more/' + banner.id} style={{padding:'8px'}} key={index}>
										<div><img src={'https://pykin.in' + banner.image} style={{ width: '30vw', height: 'auto', borderRadius: '7px' }} alt={banner.name} /></div>
									</Link>
								)))}
							</div>
						</div>
					</React.Fragment>
					}


					{store_type && store_type.slot_5_name && store_slots.slot_5.items.length > 0 &&
						<React.Fragment>
							<div style={{ "backgroundColor": store_type.top_bg_color, "position": "relative", "width": "100vw", "right": "1.5rem", "padding": "1.5rem" }}>

								<div style={{ "fontSize": "18px", "fontWeight": "700", justifyContent: 'space-between', alignItems: 'center' }} className="mt-3 d-flex">
									<span style={{ "fontSize": "18px", "fontWeight": "700", color: store_type.main_color }} >{store_type.slot_5_name}</span>
									<span className="view-more"><Link to={'/single-store-view-more/' + store_type.slot_5}>View More</Link> </span>
								</div>
								<div className="mt-3">
									<ScrollItems forceStateUpdate={this.forceStateUpdate} addProduct={this.props.addProduct} removeProduct={this.props.removeProduct} cartProducts={this.props.cartProducts} items={store_slots.slot_5 ? store_slots.slot_5.items : []} />
								</div>
							</div>
						</React.Fragment>}
				</div>




				<FloatCart />
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	promo_slides: state.promo_slides.promo_slides,
	user: state.user.user,
	locations: state.locations.locations,
	languages: state.languages.languages,
	cartProducts: state.cart.products,
});




export default connect(
	mapStateToProps,
	{
		addProduct,
		removeProduct,
	}
)(SingleStore);